import React, { Component } from "react";
import {
  Transition,
  TextArea,
  Table,
  Popup,
  Header,
  Icon,
  Grid
} from "semantic-ui-react";
import TablaResultados from "./filaAcciones/TablaResultados";
import { ventasTypes } from "../../../../../../ducks/ventas/";
import debounce from "lodash/debounce";

class FilaAcciones extends Component {
  state = {
    visible: false,
    resultados: "",
    verTextarea: false,
    editando: false
  };

  /*- Lifecycle methods -*/
  componentDidMount() {
    const {
      RESULTADO_ACCION_MAIL,
      RESULTADO_ACCION_TELEFONO,
      RESULTADO_ACCION_VISITA,
      RESULTADO_ACCION_EXTERNO
    } = ventasTypes;
    const { tipo } = this.props.datos;

    this.setState({
      resultados:
        tipo === "correo"
          ? RESULTADO_ACCION_MAIL
          : tipo === "telefono"
            ? RESULTADO_ACCION_TELEFONO
            : tipo === "visita"
              ? RESULTADO_ACCION_VISITA
              : RESULTADO_ACCION_EXTERNO
    });
  }

  /*- handle Methods-*/
  handleClick = () => {
    const { idAccion, open, idColegio } = this.props.datos;
    this.props.cerrarAccionDeVenta({ idAccion, open: !open, idColegio });
  };

  handleAddNota = () =>
    this.setState(({ verTextarea }) => ({ verTextarea: !verTextarea }));

  handleCloseNota = () => this.setState({ verTextarea: false });

  handleInput = () => this.setState({ editando: true });

  handleTextareaChange = debounce((e, { value }) => {
    const { idAccion } = this.props.datos;
    this.setState(state => ({ editando: false }));
    this.props.guardarNota({ idAccion, value });
  }, 500);

  mostrarResultados = () => this.setState(state => ({ visible: true }));

  ocultarResultados = () => this.setState(state => ({ visible: false }));

  /*- Render Helpers Methods-*/
  renderActionColumn = () => (
    <Popup
      content={this.props.datos.open ? "Finalizar acción" : "Abrir acción"}
      trigger={
        <Table.Cell
          icon={this.props.datos.open ? "unlock alternate" : "lock"}
          textAlign="center"
          onClick={this.handleClick}
          collapsing
          style={{ cursor: "pointer" }}
        />
      }
    />
  );

  renderResultadoAccion = () => (
    <Popup
      onClose={this.ocultarResultados}
      hoverable
      trigger={
        <Table.Cell
          content={this.props.datos.resultado}
          onClick={this.mostrarResultados}
          collapsing
          style={{ cursor: "pointer" }}
        />
      }
    >
      <Header as="h4" content="Cambiar Acción" />
      {this.state.visible && (
        <TablaResultados
          idAccion={this.props.datos.idAccion}
          opciones={this.state.resultados}
          cambiarResultado={this.props.cambiarResultadoAccion}
        />
      )}
    </Popup>
  );

  renderNotas = () => (
    <Popup
      hoverable
      wide
      onClose={this.handleCloseNota}
      trigger={
        <Table.Cell
          icon={this.props.datos.nota ? "edit" : "pencil"}
          collapsing
          onClick={this.handleAddNota}
        />
      }
    >
      <Header as="h5">
        <Grid columns={2}>
          <Grid.Column>
            <Header.Content>
              {this.props.datos.nota ? "Nota:" : "No hay anotación"}
            </Header.Content>
          </Grid.Column>
          <Grid.Column>
            <Transition.Group animation="fade" duration={250}>
              {this.state.editando && (
                <Icon name={this.state.editando ? "pencil" : "check"} />
              )}
            </Transition.Group>
          </Grid.Column>
        </Grid>
      </Header>

      {this.props.datos.nota &&
        !this.state.verTextarea && <p>{this.props.datos.nota}</p>}
      {this.state.verTextarea && (
        <TextArea
          defaultValue={this.props.datos.nota}
          onChange={this.handleTextareaChange}
          onInput={this.handleInput}
        />
      )}
    </Popup>
  );

  render() {
    const {
      idAccion,
      personaNombre,
      personaFormaContacto,
      timestamp,
      open,
      tipo
    } = this.props.datos;

    const fecha = new Date(timestamp).toLocaleDateString();

    const icon =
      tipo === "correo"
        ? "at"
        : tipo === "telefono"
          ? "phone"
          : tipo === "visita"
            ? "travel"
            : "external";

    return (
      <Table.Row key={idAccion} positive={open} negative={!open}>
        <Table.Cell content={fecha} collapsing />
        <Table.Cell content={personaNombre} collapsing />
        <Table.Cell content={personaFormaContacto} icon={icon} />
        {this.renderResultadoAccion()}
        {this.renderNotas()}
        {this.renderActionColumn()}
      </Table.Row>
    );
  }
}

export default FilaAcciones;



// WEBPACK FOOTER //
// ./src/pages/ventas/ventas/tablaColegios/filaColegios/tablaAcciones/FilaAcciones.jsx